var map = {
	"./s0.png": "8117",
	"./s1.png": "5ed2",
	"./s2.png": "8955",
	"./s3.png": "ee1c",
	"./s4.png": "dc70",
	"./s5.png": "6dd6",
	"./snzj.png": "7a8c",
	"./sp1.png": "8adc",
	"./sp2.png": "0191",
	"./sp3.png": "f406",
	"./sp4.png": "14ea",
	"./sp5.png": "18c8",
	"./sp6.png": "da2f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1f47";